var _circle, _rect, _rect2, _rect3, _path, _path2, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFoundImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 425,
    height: 293,
    viewBox: "0 0 425 293",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 226.176,
    cy: 154.641,
    r: 127.29,
    fill: "#EAEEF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 330.322,
    y: 16.8315,
    width: 6.31188,
    height: 42.0792,
    rx: 3.15594,
    fill: "url(#paint0_linear_215_17750)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 401.926,
    y: 84.6382,
    width: 6.31188,
    height: 42.0792,
    rx: 3.15594,
    transform: "rotate(90.6534 401.926 84.6382)",
    fill: "url(#paint1_linear_215_17750)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 385.226,
    y: 31.5596,
    width: 6.31188,
    height: 42.0792,
    rx: 3.15594,
    transform: "rotate(44.8104 385.226 31.5596)",
    fill: "url(#paint2_linear_215_17750)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.094 88.3665C103.094 83.7186 106.862 79.9507 111.51 79.9507H334.53C339.178 79.9507 342.946 83.7186 342.946 88.3665V98.8863H103.094V88.3665Z",
    fill: "url(#paint3_linear_215_17750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.094 98.8862H342.946V233.54C342.946 238.188 339.178 241.956 334.53 241.956H111.51C106.862 241.956 103.094 238.188 103.094 233.54V98.8862Z",
    fill: "url(#paint4_linear_215_17750)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.198,
    cy: 63.119,
    r: 6.31188,
    fill: "#EAEEF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 355.569,
    cy: 21.0399,
    r: 6.31188,
    fill: "#EAEEF9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5349,
    cy: 189.356,
    r: 12.6238,
    fill: "#EAEEF9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.718,
    cy: 90.4706,
    r: 4.20792,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.446,
    cy: 90.4706,
    r: 4.20792,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.173,
    cy: 90.4706,
    r: 4.20792,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.325 185.261V180.045L185.336 143.636H189.12V151.716H186.563L169.177 179.227V179.636H200.165V185.261H162.325ZM186.972 196V183.676V181.247V143.636H193.006V196H186.972ZM223 196.716C219.148 196.716 215.866 195.668 213.156 193.571C210.446 191.457 208.375 188.398 206.943 184.392C205.511 180.369 204.795 175.511 204.795 169.818C204.795 164.159 205.511 159.327 206.943 155.321C208.392 151.298 210.472 148.23 213.182 146.116C215.909 143.986 219.182 142.92 223 142.92C226.818 142.92 230.082 143.986 232.793 146.116C235.52 148.23 237.599 151.298 239.031 155.321C240.48 159.327 241.205 164.159 241.205 169.818C241.205 175.511 240.489 180.369 239.057 184.392C237.625 188.398 235.554 191.457 232.844 193.571C230.134 195.668 226.852 196.716 223 196.716ZM223 191.091C226.818 191.091 229.784 189.25 231.898 185.568C234.011 181.886 235.068 176.636 235.068 169.818C235.068 165.284 234.582 161.423 233.611 158.236C232.656 155.048 231.276 152.619 229.469 150.949C227.679 149.278 225.523 148.443 223 148.443C219.216 148.443 216.259 150.31 214.128 154.043C211.997 157.759 210.932 163.017 210.932 169.818C210.932 174.352 211.409 178.205 212.364 181.375C213.318 184.545 214.69 186.957 216.48 188.611C218.287 190.264 220.46 191.091 223 191.091ZM245.866 185.261V180.045L268.878 143.636H272.662V151.716H270.105L252.719 179.227V179.636H283.707V185.261H245.866ZM270.514 196V183.676V181.247V143.636H276.548V196H270.514Z",
    fill: "url(#paint5_linear_215_17750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_215_17750",
    x1: 329.928,
    y1: 37.8711,
    x2: 343.705,
    y2: 37.8711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8932F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B152B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_215_17750",
    x1: 401.532,
    y1: 105.678,
    x2: 415.309,
    y2: 105.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8932F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B152B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_215_17750",
    x1: 384.832,
    y1: 52.5992,
    x2: 398.609,
    y2: 52.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8932F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B152B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_215_17750",
    x1: 88.1152,
    y1: 89.4185,
    x2: 611.646,
    y2: 89.4186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8932F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B152B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_215_17750",
    x1: 223.02,
    y1: 98.8862,
    x2: 205.136,
    y2: 434.468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563886,
    stopColor: "#CED7E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_215_17750",
    x1: 149.881,
    y1: 169.5,
    x2: 433.636,
    y2: 169.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8932F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B152B",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundImg);
export default __webpack_public_path__ + "static/media/NotFoundImg.6c2d35535d3926f848c8bbd76fdffe8a.svg";
export { ForwardRef as ReactComponent };